import * as React from 'react';
import { useEffect } from 'react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/academic-integrity';

const TRANSIENT_DURATION = 5000; // ms

type Props = {
  onDismiss: () => void;
};

const CopyDeterrenceNotification: React.FC<Props> = ({ onDismiss }) => {
  useEffect(() => {
    const timerId = setTimeout(() => onDismiss(), TRANSIENT_DURATION);
    return () => {
      clearTimeout(timerId);
    };
  });
  return (
    <InlineNotification severity="information" onDismiss={onDismiss}>
      {_t('The option to copy question text is disabled on assessments.')}
    </InlineNotification>
  );
};

export default CopyDeterrenceNotification;
